import { useState } from "react";
import { Vehicle } from "@/types/vehicle.types";

export function useVehicleLoading() {
  const [vehicleLoading, setVehicleLoading] = useState<boolean>(false);
  const [selectedVehicles, setSelectedVehicles] = useState<Vehicle[]>([]);

  const addVehicle = (vehicle: Vehicle) => {
    // Append the new vehicle to the existing array
    setSelectedVehicles(prev => {
      if (!prev) return [vehicle]; // if undefined, create new array
      return [...prev, vehicle];
    });
  };

  const removeVehicle = (id: number) => {
    setSelectedVehicles(prev => prev?.filter(v => v.id !== id));
  };

  const clearVehicles = () => {
    setSelectedVehicles([])
  }

  return {
    vehicleLoading,
    setVehicleLoading,
    selectedVehicles,
    addVehicle,
    removeVehicle,
    clearVehicles
  };
}